import React from "react";
import { RCCLov } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";
import { useTranslation } from "src/context/Translations/context";

const LovCategoriesOccurrences: React.FC<Omit<ILovComponent, 
	"valueProperty" | 
	"labelProperty" | 
	"routeAPI" | 
	"routeAPICreate" | 
	"formatCreateLabel" | 
	"callbackErrorOnCreate" |
	"isCreatable">
 > = ({
 	name,
 	control,
 	label,
 	...rest
 }) => {
 	const { translate } = useTranslation();
	
 	return(
 		<RCCLov 
 			label={label}
 			name={name} 
 			control={control}
 			routeAPI="CategoriesOccurrences/Lov"
 			valueProperty="Oca004Id"
 			labelProperty="Oca004Descricao"
 			elementsPerPage={20}
 			placeholder={translate("Digite para filtrar as opções")}
 			{...rest}
 		/>
 	);
 };

export default LovCategoriesOccurrences;
